"use client";

import { useEffect, useState } from "react";
import { CategoriesResponse } from "@/types/category";
import useUserStore from "@/global-store/user";
import NavbarDropdown from "./navbar-dropdown";
import { ContactSupport, ContactOrders, ContactUser } from "./Navbar";
import SearchBar from "./search-bar";

interface Props {
  categories: CategoriesResponse[];
}

export const MobileNavbar = ({ categories }: Props) => {
  const user = useUserStore((state) => state.user);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(!open);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 960) {
        setOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <button onClick={handleOpen} className="m-5 mx-1 text-primary">
        {open ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            fill="currentColor"
            className="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            fill="currentColor"
            className="bi bi-list"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
            />
          </svg>
        )}
      </button>
      {open && (
        <div className="absolute top-24 left-0 bg-white w-full flex flex-col py-4 sm:flex-row justify-between shadow-lg lg:hidden">
          <div className="flex justify-center gap-2 items-center sm:pl-3 flex-wrap">
            <NavbarDropdown categories={categories} />
            <ContactSupport />
            <ContactOrders />
            <ContactUser />
          </div>
          <div className="flex my-3 mx-4 justify-center items-center border-gray-inputBorder rounded max-w-xl">
            {!user && <SearchBar />}
          </div>
        </div>
      )}
    </>
  );
};
